import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/** Redirects /employer/profile/:emtId to canonical /p/:emtId */
export default function EmployerProfileRedirect() {
  const { emtId } = useParams<{ emtId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (emtId) {
      navigate(`/p/${emtId}`, { replace: true });
    } else {
      navigate('/employer/dashboard', { replace: true });
    }
  }, [emtId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[var(--text-secondary)]">
      Redirecting…
    </div>
  );
}
